/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * Historic type of purchases of the purchased item.
 */
export const PurchaseIteration = /* #__PURE__ */ parsers.exactly('first', 'second');
